import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, ControlLabel, Form, FormControl, FormGroup, Modal } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import Papa from 'papaparse';
import ImportWeightsExample from './ImportWeightExample';

const VALIDATION_SCHEMA = yup.object().shape({
  weightSchemeImportFile: yup.mixed().required(),
});

class WeightSchemeImportDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.renderForm = this.renderForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(values, formik) {
    const onDataImported = this.props.onUpdateEvent;
    Papa.parse(values.weightSchemeImportFile, {
      skipEmptyLines: true,
      header: true,
      complete: function(results) {
        const data = results.data;

        // send result to state
        const weights = data.map(row => {
          const matchPercentPriceModifiers = [
            {
              name: 'p0',
              lowerBound: 0,
              percentage: row.p0,
            },
            {
              name: 'p50',
              lowerBound: 0.5,
              percentage: row.p50,
            },
            {
              name: 'p75',
              lowerBound: 0.75,
              percentage: row.p75,
            },
            {
              name: 'p85',
              lowerBound: 0.85,
              percentage: row.p85,
            },
            {
              name: 'p95',
              lowerBound: 0.95,
              percentage: row.p95,
            },
            {
              name: 'p100',
              lowerBound: 1,
              percentage: row.p100,
            },
            {
              name: 'p101',
              lowerBound: 1.01,
              percentage: row.p101,
            },
          ];

          const repetitionPriceModifier = {
            percentage: row.repetition,
          };

          return {
            languagePair: {
              sourceLocale: row.sourceLocale,
              targetLocale: row.targetLocale,
            },
            matchPercentPriceModifiers: matchPercentPriceModifiers,
            repetitionPriceModifier: repetitionPriceModifier,
          };
        });
        onDataImported(weights);
      },
    });
    this.props.closeHandler();
  }

  renderForm({ values, errors, touched, handleSubmit, handleChange, handleBlur, setFieldValue }) {
    const { closeHandler, title } = this.props;
    const handleCancel = () => {
      closeHandler(undefined);
    };

    return (
      <div>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ImportWeightsExample />
          <Form>
            <FormGroup controlId="weightSchemeImportFile">
              <Col componentClass={ControlLabel} sm={3}>
                File
              </Col>
              <Col sm={8}>
                <FormControl
                  name="weightSchemeImportFile"
                  type="file"
                  accept={'.csv'}
                  onChange={event => {
                    setFieldValue('weightSchemeImportFile', event.currentTarget.files[0]);
                  }}
                  onBlur={handleBlur}
                />
                <FormControl.Feedback />
              </Col>
            </FormGroup>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button bsStyle={'primary'} onClick={handleSubmit}>
            Import
          </Button>
        </Modal.Footer>
      </div>
    );
  }

  render() {
    return (
      <Formik
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={this.handleSubmit}
        validateOnChange={true}
        render={this.renderForm}
      />
    );
  }
}

WeightSchemeImportDialog.propTypes = {
  closeHandler: PropTypes.func,
  onUpdateEvent: PropTypes.func,
  weightScheme: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

WeightSchemeImportDialog.defaultProps = {
  closeHandler: Function.prototype,
  onUpdateEvent: Function.prototype,
};

export default WeightSchemeImportDialog;
